import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SeguroComponent } from './MiSeguro/seguro/seguro.component';
import { NavbarComponent } from './Components/shared/navbar/navbar.component';
import { TabsPanelComponent } from './Components/shared/tabs-panel/tabs-panel.component';
import { ViajesComponent } from './MisViajes/viajes/viajes.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SuraSelectComponent } from './Components/sura-select/sura-select.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { MesGastadoComponent } from './MiSeguro/mes-gastado/mes-gastado.component';
import { UltUbicacionComponent } from './MiSeguro/ult-ubicacion/ult-ubicacion.component';
import { KmsRecorridosComponent } from './MiSeguro/kms-recorridos/kms-recorridos.component';
import { MesesRecorridosComponent } from './MiSeguro/meses-recorridos/meses-recorridos.component';
import { PolizaComponent } from './MiSeguro/poliza/poliza.component';
import { CicloFacturacionComponent } from './MiSeguro/ciclo-facturacion/ciclo-facturacion.component';
import { AgmCoreModule } from '@agm/core';
import { ErrorComponent } from './error/error.component';
import { HomeComponent } from './home/home.component';
import { LandingComponent } from './landing/landing.component';
import { DetallePolizaComponent } from './MiSeguro/detalle-poliza/detalle-poliza.component';
import { SuraLoaderComponent } from './Components/shared/sura-loader/sura-loader.component';
import { AsistenciasComponent } from './MiSeguro/asistencias/asistencias.component';
import { ErrorTechniquesComponent } from './error-techniques/error-techniques.component';
import { SuraSelectGralComponent } from './Components/sura-select-gral/sura-select-gral.component';
import { TimelineComponent } from './MisViajes/timeline/timeline.component';
import { SlickModule } from 'ngx-slick';
import { MapaRutaComponent } from './Components/mapa-ruta/mapa-ruta.component';
import { ListaViajesComponent } from './MisViajes/lista-viajes/lista-viajes.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import localeCL from '@angular/common/locales/es-CL';
import { registerLocaleData } from '@angular/common';
import { DatetimerangepickerModule } from "angular-datetimerangepicker";
import { EventosComponent } from './MisEventos/eventos/eventos.component';
import { ResumenEventosComponent } from './MisEventos/resumen-eventos/resumen-eventos.component';
import { ResumenEventosmapaComponent } from './MisEventos/resumen-eventosmapa/resumen-eventosmapa.component';
import { DetalleEventosComponent } from './MisEventos/detalle-eventos/detalle-eventos.component';
import { MapaEventosComponent } from './MisEventos/mapa-eventos/mapa-eventos.component';
import { SuraSelectMisViajesComponent } from './Components/sura-select-mis-viajes/sura-select-mis-viajes.component';
import { SafeHtmlPipe } from 'src/app/Components/shared/SafeHtmlPipe';
import { AppInsightsService } from './Services/appInsight.service';
import { MonitoringInterceptor } from './Services/Interceptor/monitoring.interceptor';
import { AutoComponent } from './MiAuto/auto/auto.component';
import { DataTablesModule } from 'angular-datatables';
import { MenuAutoComponent } from './MiAuto/menu-auto/menu-auto.component';
import { ClickOutsideModule } from 'ng-click-outside';
import { Daterangepicker } from 'ng2-daterangepicker';
import { environment } from '../environments/environment';
import { GoogleTagManagerModule, GoogleTagManagerService } from 'angular-google-tag-manager';
import { NuevaVistaComponent } from './MisEventos/nueva-vista/nueva-vista.component';

registerLocaleData(localeCL);

@NgModule({
  declarations: [
    AppComponent,
    SeguroComponent,
    NavbarComponent,
    TabsPanelComponent,
    ViajesComponent,
    SuraSelectComponent,
    MesGastadoComponent,
    UltUbicacionComponent,
    KmsRecorridosComponent,
    MesesRecorridosComponent,
    CicloFacturacionComponent,
    PolizaComponent,
    ErrorComponent,
    HomeComponent,
    LandingComponent,
    DetallePolizaComponent,
    SuraLoaderComponent,
    AsistenciasComponent,
    ErrorTechniquesComponent,
    SuraSelectGralComponent,
    TimelineComponent,
    MapaRutaComponent,
    ListaViajesComponent,
    EventosComponent,
    ResumenEventosComponent,
    ResumenEventosmapaComponent,
    DetalleEventosComponent,
    MapaEventosComponent,
    SuraSelectMisViajesComponent,
    SafeHtmlPipe,
    AutoComponent,
    MenuAutoComponent,
    NuevaVistaComponent
  ],
  entryComponents: [NuevaVistaComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    NgbModule,
    DatetimerangepickerModule,
    ClickOutsideModule,
    DataTablesModule,
    Daterangepicker,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyClEuV6wNDcs9ZCAy0oNtTy_6ejIwEAQSQ'
    }),
    SlickModule.forRoot(),
    GoogleTagManagerModule.forRoot({
      id: environment.gtmId,
    }),
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-CL'},
    { provide: HTTP_INTERCEPTORS, useClass: MonitoringInterceptor, multi: true },
    AppInsightsService,
    GoogleTagManagerService
  ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
})
export class AppModule { }
